// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1024px) {
  .welcome-align {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 2em;
    width: 33%;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2em;
  }
}
@media (min-width: 1024px) and (max-width: 1640px) {
  .welcome-align {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 2em;
    width: 65%;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2em;
  }
}
@media (min-width: 1641px) {
  .welcome-align {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 2em;
    width: 33%;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2em;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
